import { render, staticRenderFns } from "./DiseaseStats.vue?vue&type=template&id=20ec0a9c&scoped=true"
import script from "./DiseaseStats.vue?vue&type=script&lang=js"
export * from "./DiseaseStats.vue?vue&type=script&lang=js"
import style0 from "./DiseaseStats.vue?vue&type=style&index=0&id=20ec0a9c&prod&scoped=true&lang=css"
import style1 from "./DiseaseStats.vue?vue&type=style&index=1&id=20ec0a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec0a9c",
  null
  
)

export default component.exports